import { buttonLink } from '@insify/css/classes.module.css';
import { Modal } from '@insify/design-system/components';
import { textXsSemibold } from '@insify/design-system/typography';
import { TrackedButton } from '@objectiv/tracker-react';
import clsx from 'clsx';
import { useState } from 'react';
import { Trans } from 'react-i18next';

import { useCommands } from '../../../../../hooks/useCommands';

export const EmailSendOld = ({ email, children }: { email: string; children?: React.ReactNode }): JSX.Element => {
  const { sendCommand } = useCommands();
  const [isModalOpened, setIsModalOpened] = useState(false);

  const handleClick = () => {
    void sendCommand({
      type: 'requestQuoteEmail',
      payload: {},
    });
    setIsModalOpened(true);
  };

  return (
    <>
      <TrackedButton
        type='button'
        objectiv={{ id: 'quote-email-footnote' }}
        data-testid='quote-email-footnote'
        onClick={handleClick}
        className={clsx(textXsSemibold, buttonLink)}
      >
        {children}
      </TrackedButton>
      <Modal trackingId='quote-email-footnote-modal' open={isModalOpened} onClose={() => setIsModalOpened(false)}>
        <Trans i18nKey='funnel:checkout_request_quote_email_success' values={{ email }} parent='p' />
      </Modal>
    </>
  );
};
